import { isEnterprisePlan } from "@common/utils/plan";
import { customerStore } from "@stores/customer";
import { paymentMethodsStore } from "@stores/payment-methods";
import { purchasesStore } from "@stores/purchases";
import { HEADER_NAV_HEIGHT, HEADER_NAV_HEIGHT_WITH_MESSAGE } from "./constants";

export function useGetHeaderProperties() {
  // customer
  const { isLoading: customerDetailsLoading, data: customerDetails } =
    customerStore.useGetDetails();

  // purchases
  const { isLoading: loadingPurchases, data: purchases } =
    purchasesStore.useGetPurchases();

  // payment
  const { isLoading: loadingDefaultPaymentMethod, data: defaultPaymentMethod } =
    paymentMethodsStore.useDefaultPaymentMethod();

  // purchase in trial
  const purchaseInTrial = purchases
    ?.filter(({ product }) => !isEnterprisePlan(product.plan.alias))
    .find(({ subscription }) => subscription.in_trial);

  // banners
  const canHaveBanner = !customerDetailsLoading;
  const hasTrialBanner =
    canHaveBanner && !loadingPurchases && !!purchaseInTrial;
  const hasBillingAddressBanner =
    canHaveBanner &&
    !loadingDefaultPaymentMethod &&
    !!defaultPaymentMethod &&
    !customerDetails?.billing_address;
  const hasBanner = hasTrialBanner || hasBillingAddressBanner;

  return {
    isLoading:
      customerDetailsLoading || loadingPurchases || loadingDefaultPaymentMethod,
    hasTrialBanner,
    hasBillingAddressBanner,
    hasBanner,
    headerHeight: hasBanner
      ? HEADER_NAV_HEIGHT_WITH_MESSAGE
      : HEADER_NAV_HEIGHT,
  };
}
